import React, { Component } from 'react';
const formatCurrency = require('format-currency');
import axios from 'axios';

import { getProductServicesArray } from '../../functions/getProductServicesArray';
import Loader from '../loader';
import AddToCartSelector from './AddToCartSelector';
import HorizontalLoader from './HorizontalLoader';
import NotAvailable from './NotAvailable';
import ProviderDetails from './ProviderDetails';
import UpsellOverlay from './UpsellOverlay';

class DetailsWithPrice extends Component {
	constructor(props) {
		super(props);
		this.productBox = React.createRef();
		this.state = {
			showProviderDetails: false,
			productBoxWidth: 0,
			productBoxHeight: 0,
			open: false,
			quantity: 1,
			stock: 'InStock',
			integratedLocationsHeight: null,
			forceState: false,
		};
		this.getProviderDetails = this.getProviderDetails.bind(this);
	}

	componentDidMount() {
		this.setState({
			integratedLocationsHeight: 330,
			productBoxWidth: this.productBox.current.offsetWidth,
			productBoxHeight: this.productBox.current.offsetHeight,
		});
	}

	getProviderDetails = () => {
		if (
			!this.props.item ||
			!this.props.item.isAvailable ||
			!this.props.geolocation ||
			!this.props.item.selectedProviderService
		) {
			return null;
		}

		const { latitude, longitude } = this.props.geolocation;
		const { ProviderId } = this.props.item.selectedProviderService.providerId;
		if (ProviderId && latitude != undefined) {
			let _this = this;
			let url = `https://api.marketring-api.com/v1/providerlocations/${ProviderId}?GoogleData=true&lat=${latitude}&lng=${longitude}`; // Call from Cache..

			var result = axios
				.get(url, { crossdomain: true })
				.then(response => {
					_this.setState({
						providerDetails: response.data,
						showProviderDetails: true,
					});
				})
				.catch(error => {
					return null;
				});
			return result;
		} else {
			return null;
		}
	};

	onOpenModal = () => {
		this.setState({ open: true });
	};

	onCloseModal = () => {
		this.setState({ open: false });
	};

	minusQty = () => {
		if (this.state.quantity > 1) {
			this.setState({ stock: 'In Stock' });
			this.setState({ quantity: this.state.quantity - 1 });
		}
	};

	plusQty = () => {
		this.setState({ quantity: this.state.quantity + 1 });
	};

	changeQty = e => {
		this.setState({ quantity: parseInt(e.target.value) });
	};

	// Hack for forcing state to re-render when provider changed.
	forceState = () => {
		this.setState({ forceState: !this.state.forceState });
	};

	render() {
		const {
			symbol,
			addToWishlistClicked,
			applicationLabel,
			applicationSlug,
			provider,
			addToCartClicked,
			cartlist,
			externalrequest,
			reviews,
			geolocation,
			productIsLoading,
		} = this.props;

		var baseitem = this.props.item;

		var { item, serviceArray, selectedServiceIndex, optionalServiceArray } = getProductServicesArray(
			baseitem,
			0,
			provider,
			externalrequest
		);
		// Find the Index of the Service Array.. and then the Item .find(el => el.urlSlug === productId),

		// if provider <> 0 find in array and pop to front.
		item.applicationLabel = applicationLabel ? applicationLabel.trim() : '';
		item.ProductSpecifications = [];
		item.videoUrl = null;
		//  Add Return URL
		// If Service Array is Empty Disable Buy Now and Add to Cart Button.  ( Product is not available in your Area...)
		var productUrl = `/product/${item.urlSlug}`;

		if (applicationSlug != undefined) {
			productUrl = `${productUrl}/${applicationSlug}`;
		}
		item.returnUrl = productUrl;

		const AppLabel = item.applicationLabel ? 'Fits: ' + item.applicationLabel : '';
		const msrp = Math.round(item.price * 1.15, 2);

		const providerMsrp = item?.selectedProviderService?.providerId
			? Math.round(item.selectedProviderService.providerId.Price * 1.15, 2)
			: undefined;

		// If any of servicas is available it means the product is available
		const hasAvailableServices = serviceArray.length > 0;

		// If the only service available is the priceOnly, a fake one.
		const hasOnlyPriceOnlyService = serviceArray.length === 1 && serviceArray[0].isShowPriceOnly;
		// geolocation.isLoading ? does it work?
		return (
			<div ref={this.productBox}>
				<div className="product-sidebar">
					{/* Show/hide via DOM and css */}
					{this.state.showProviderDetails && (
						<ProviderDetails
							onProductPage
							optionalServiceArray={optionalServiceArray}
							show={this.state.showProviderDetails}
							data={this.state.providerDetails}
							width={this.state.productBoxWidth}
							height={this.state.productBoxHeight * 1.5}
							left={-this.state.productBoxWidth - 15}
							close={() =>
								this.setState({
									showProviderDetails: false,
								})
							}
							reviews={reviews}
						/>
					)}

					<div className="intro-container">
						<div className="text-container">
							<h1 className="sku">{item.name}</h1>
						</div>

						<div className="numbers-container">
							{productIsLoading && (
								<div className="horizontal-loader">
									<Loader />
								</div>
							)}

							{(typeof item.selectedProviderService !== 'undefined' &&
								Object.keys(item.selectedProviderService).length !== 0 &&
								!serviceArray[selectedServiceIndex].DisableCart) ||
							!hasAvailableServices ? (
								<div className="price">
									<span className="old-price">
										<del>
											${symbol}
											{formatCurrency(providerMsrp || msrp)}
										</del>
										<span>15% off</span>
									</span>
									<span className="valid-price">
										{symbol}$
										{formatCurrency(item?.selectedProviderService?.providerId?.Price || item.price)}{' '}
									</span>
								</div>
							) : (
								<div className="price not-available">
									<span className="old-price">
										<span>
											<i className="fas fa-info-circle"></i> Please call for Price
										</span>
									</span>
								</div>
							)}
						</div>
					</div>

					<h2 className="short-description">
						{item.shortDescription} {applicationLabel && `for ${applicationLabel}`}
					</h2>

					{this.props.renderTransferOverlay ? (
						<UpsellOverlay geolocation={geolocation} urlSlug={this.props.item.category?.urlSlug} />
					) : hasAvailableServices ? (
						hasOnlyPriceOnlyService ? (
							<NotAvailable
								categoryUrlSlug={item.category?.urlSlug}
								geolocation={geolocation}
								isLoading={productIsLoading}
							/>
						) : (
							<AddToCartSelector
								isLoading={productIsLoading}
								cartlist={cartlist}
								optionalServiceArray={optionalServiceArray}
								serviceArray={serviceArray}
								selectedServiceIndex={selectedServiceIndex}
								item={item}
								addToWishlistClicked={addToWishlistClicked}
								addToCartClicked={addToCartClicked}
								setSelectedProvider={this.props.setSelectedProvider}
								showProviderDetails={() => this.getProviderDetails()}
								provider={provider}
								forceState={this.forceState}
								showReviews={this.props.showReviews}
								reviews={reviews}
								showFitment={this.props.showFitment}
							/>
						)
					) : (
						<NotAvailable
							categoryUrlSlug={item.category?.urlSlug}
							geolocation={geolocation}
							isLoading={productIsLoading}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default DetailsWithPrice;
